<app-side-menu>
  <div class="purchase-order-details-container">
    <!-- Loading -->
    <div *ngIf="isLoading" class="loading-overlay">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Carregando...</span>
      </div>
    </div>

    <!-- Error Message -->
    <div *ngIf="error" class="alert alert-danger" role="alert">
      <div class="d-flex justify-content-between align-items-center">
        <div>
          <i class="fas fa-exclamation-triangle me-2"></i>
          {{ error }}
        </div>
        <button 
          type="button" 
          class="btn btn-outline-danger btn-sm"
          (click)="retryLoad()">
          <i class="fas fa-redo me-1"></i>
          Tentar Novamente
        </button>
      </div>
    </div>

    <!-- Conteúdo Principal -->
    <div *ngIf="!isLoading && !error && purchaseOrder">
      <!-- Cabeçalho -->
      <div class="details-header">
        <div class="d-flex justify-content-between align-items-start">
          <div>
            <h1 class="details-title">
              <i class="fas fa-shopping-cart me-2"></i>
              {{ detailsDocumentLabel }} {{ purchaseOrder.orderNumber }}
            </h1>
            <p class="details-subtitle">
              Solicitado em {{ formatDate(purchaseOrder.requestDate) }}
            </p>
          </div>
          <div class="d-flex gap-2">
            <button 
              type="button" 
              class="btn btn-outline-secondary"
              (click)="goBack()">
              <i class="fas fa-arrow-left me-1"></i>
              Voltar
            </button>
            <ng-container *ngIf="!isSolicitacaoComprasFlow">
              <ng-container *appHasPermission="'PurchaseOrders.Approve'">
                <button
                  type="button"
                  class="btn btn-primary"
                  (click)="selectDetailsTab('approval-tracking')"
                  title="Abre a aba onde o aprovador da faixa registra a decisão (aprovar ou rejeitar a compra).">
                  <i class="fas fa-clipboard-check me-1"></i>
                  Aprovação da compra
                </button>
              </ng-container>
              <button
                type="button"
                class="btn btn-outline-primary"
                (click)="goToQuotations()"
                title="Orçamentos e propostas de fornecedores">
                <i class="fas fa-balance-scale me-1"></i>
                Cotações
              </button>
            </ng-container>
            <button 
              type="button" 
              class="btn btn-warning"
              *ngIf="canEdit()"
              (click)="editOrder()">
              <i class="fas fa-edit me-1"></i>
              Editar
            </button>
            <ng-container *ngIf="isSolicitacaoComprasFlow">
              <ng-container *appHasPermission="'PurchaseOrders.Approve'">
                <button
                  type="button"
                  class="btn btn-primary"
                  *ngIf="canOpenManagerDecision()"
                  (click)="goToManagerDecision()">
                  <i class="fas fa-clipboard-check me-1"></i>
                  Decisão do gestor
                </button>
              </ng-container>
            </ng-container>
            <button 
              type="button" 
              class="btn btn-danger"
              *ngIf="canCancel()"
              (click)="cancelOrder()">
              <i class="fas fa-times me-1"></i>
              Cancelar
            </button>
          </div>
        </div>
      </div>

      <ul class="nav nav-tabs mb-3 px-0 border-bottom">
        <li class="nav-item">
          <button
            type="button"
            class="nav-link"
            [class.active]="detailsTab === 'overview'"
            (click)="selectDetailsTab('overview')">
            Visão geral
          </button>
        </li>
        <li class="nav-item" *ngIf="!isSolicitacaoComprasFlow">
          <button
            type="button"
            class="nav-link"
            [class.active]="detailsTab === 'approval-tracking'"
            (click)="selectDetailsTab('approval-tracking')">
            Rastreamento de aprovações
          </button>
        </li>
      </ul>

      <ng-container *ngIf="detailsTab === 'overview'">
      <ng-container *ngIf="!isSolicitacaoComprasFlow">
        <ng-container *appHasPermission="'PurchaseOrders.Approve'">
          <div class="alert alert-primary border-0 shadow-sm mb-4 po-approve-hint">
            <div class="d-flex flex-wrap align-items-start justify-content-between gap-3">
              <div>
                <strong class="d-block mb-1">
                  <i class="fas fa-stamp me-2"></i>
                  Onde o responsável pela faixa aprova a compra
                </strong>
                <p class="mb-0 small">
                  Caminho: menu <strong>Compras → Lista de Pedidos</strong>, abra o pedido e use o botão azul
                  <strong>Aprovação da compra</strong> (no topo) ou a aba
                  <strong>Rastreamento de aprovações</strong>. Na seção <em>Etapa atual</em>, preencha comentário ou motivo e clique em
                  <strong>Aprovar</strong> ou <strong>Rejeitar</strong>.
                </p>
              </div>
              <button type="button" class="btn btn-sm btn-light shrink-0" (click)="selectDetailsTab('approval-tracking')">
                Abrir aba de aprovação
              </button>
            </div>
          </div>
        </ng-container>
      </ng-container>
      <!-- Informações Básicas (largura total, uma seção por linha) -->
      <div class="row mb-4">
        <div class="col-12">
          <div class="info-card">
            <h5 class="card-title">
              <i class="fas fa-info-circle me-2"></i>
              Informações Básicas
            </h5>
            <div class="card-body">
              <div class="info-row">
                <label>Número do Pedido:</label>
                <span>{{ purchaseOrder.orderNumber }}</span>
              </div>
              <div class="info-row">
                <label>Status:</label>
                <span class="badge" [class]="getStatusClass(purchaseOrder.status)">
                  {{ getStatusDisplayName(purchaseOrder.status) }}
                </span>
              </div>
              <div class="info-row">
                <label>Prioridade:</label>
                <span class="badge" [class]="getPriorityClass(purchaseOrder.priority)">
                  {{ getPriorityDisplayName(purchaseOrder.priority) }}
                </span>
              </div>
              <div class="info-row">
                <label>Data de Solicitação:</label>
                <span>{{ formatDate(purchaseOrder.requestDate) }}</span>
              </div>
              <div class="info-row" *ngIf="purchaseOrder.expectedDeliveryDate">
                <label>Data Prevista de Entrega:</label>
                <span>{{ formatDate(purchaseOrder.expectedDeliveryDate) }}</span>
              </div>
              <div class="info-row" *ngIf="purchaseOrder.description">
                <label>Descrição:</label>
                <span>{{ purchaseOrder.description }}</span>
              </div>
              <div class="info-row" *ngIf="!isSolicitacaoComprasFlow && purchaseOrder.costCenterName">
                <label>Centro de custo:</label>
                <span>{{ purchaseOrder.costCenterName }}</span>
              </div>
              <div class="info-row" *ngIf="isSolicitacaoComprasFlow && purchaseOrder.rejectionReason">
                <label>Situação da Aprovação:</label>
                <span>{{ purchaseOrder.rejectionReason }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Informações Financeiras (somente fluxo completo de pedidos) -->
      <div class="row mb-4" *ngIf="!isSolicitacaoComprasFlow">
        <div class="col-12">
          <div class="info-card">
            <h5 class="card-title">
              <i class="fas fa-dollar-sign me-2"></i>
              Informações Financeiras
            </h5>
            <div class="card-body">
              <div class="info-row">
                <label>Subtotal:</label>
                <span>{{ formatCurrency(purchaseOrder.subTotal ?? 0) }}</span>
              </div>
              <div class="info-row">
                <label>Valor Total:</label>
                <span class="text-success fw-bold">{{ formatCurrency(purchaseOrder.totalAmount) }}</span>
              </div>
              <div class="info-row">
                <label>Desconto:</label>
                <span>{{ formatCurrency(purchaseOrder.totalDiscount || 0) }}</span>
              </div>
              <div class="info-row">
                <label>Impostos:</label>
                <span>{{ formatCurrency(purchaseOrder.totalTax || 0) }}</span>
              </div>
              <div class="info-row">
                <label>Frete:</label>
                <span>{{ formatCurrency(purchaseOrder.shippingCost || 0) }}</span>
              </div>
              <div class="info-row">
                <label>Centro de Custo:</label>
                <span>{{ purchaseOrder.costCenterName || 'Não informado' }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Aprovações e controle (somente pedido de compra completo) -->
      <div class="row mb-4" *ngIf="!isSolicitacaoComprasFlow">
        <div class="col-12">
          <div class="info-card">
            <h5 class="card-title">
              <i class="fas fa-clipboard-check me-2"></i>
              Aprovações e controle
            </h5>
            <div class="card-body">
              <div class="info-row">
                <label>Exige aprovação:</label>
                <span>{{ yn(purchaseOrder.requiresApproval) }}</span>
              </div>
              <div class="info-row">
                <label>Aprovação do gestor concluída:</label>
                <span>{{ yn(purchaseOrder.isManagerApprovalCompleted) }}</span>
              </div>
              <div
                class="info-row"
                *ngIf="purchaseOrder.managerApproverStaffId != null && purchaseOrder.managerApproverStaffId > 0">
                <label>Gestor designado:</label>
                <span>
                  {{
                    managerDesignatedDisplay === null
                      ? 'Carregando…'
                      : managerDesignatedDisplay
                  }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Solicitante -->
      <div class="row mb-4">
        <div class="col-12">
          <div class="info-card">
            <h5 class="card-title">
              <i class="fas fa-user me-2"></i>
              Solicitante
            </h5>
            <div class="card-body">
              <div class="info-row">
                <label>Nome:</label>
                <span>{{ purchaseOrder.requestedByStaffName || 'Não informado' }}</span>
              </div>
              <div class="info-row" *ngIf="isSolicitacaoComprasFlow">
                <label>Centro de Custo:</label>
                <span>{{ purchaseOrder.costCenterName || 'Não informado' }}</span>
              </div>
              <div class="info-row" *ngIf="isSolicitacaoComprasFlow">
                <label>Gerente Aprovador:</label>
                <span>{{ purchaseOrder.approvedByStaffName || 'Não informado' }}</span>
              </div>
              <div class="info-row">
                <label>Departamento:</label>
                <span>{{ purchaseOrder.departmentName || 'Não informado' }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Fornecedor (somente pedido de compra completo) -->
      <div class="row mb-4" *ngIf="!isSolicitacaoComprasFlow">
        <div class="col-12">
          <div class="info-card">
            <h5 class="card-title">
              <i class="fas fa-truck me-2"></i>
              Fornecedor
            </h5>
            <div class="card-body">
              <div class="info-row">
                <label>Nome:</label>
                <span>{{ purchaseOrder.supplierName || 'Não informado' }}</span>
              </div>
              <div class="info-row" *ngIf="purchaseOrder.supplierContact">
                <label>Contato:</label>
                <span>{{ purchaseOrder.supplierContact }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Itens do Pedido -->
      <div class="row mb-4">
        <div class="col-12">
          <div class="info-card">
            <h5 class="card-title">
              <i class="fas fa-list me-2"></i>
              Lista de Itens
            </h5>
            <div class="card-body">
              <app-table
                [title]="''"
                [columns]="itemColumns"
                [data]="items"
                [loading]="itemsLoading"
                [showSearch]="false"
                [clickable]="false"
                [actions]="[]"
                [itemsPerPage]="25"
                [disablePagination]="items.length <= 25">
              </app-table>

              <div *ngIf="!itemsLoading && items.length === 0" class="empty-state-simple">
                <div class="empty-message">
                  <i class="fas fa-box-open"></i>
                  <p>Nenhum item encontrado neste pedido</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Aprovações -->
      <div class="row mb-4" *ngIf="sortedApprovals.length > 0">
        <div class="col-12">
          <div class="info-card">
            <h5 class="card-title">
              <i class="fas fa-check-circle me-2"></i>
              Histórico de Aprovações
            </h5>
            <div class="card-body">
              <p class="small text-muted mb-3 mb-lg-4">
                Linhas ordenadas por <strong>ordem no fluxo</strong> e data. Mostram ação, situação na API, nível,
                responsável e observações (comentário, rejeição ou alterações solicitadas).
              </p>
              <div class="approval-timeline">
                <div
                  *ngFor="let approval of sortedApprovals; let last = last"
                  class="approval-item approval-item-rich"
                  [class.approval-item-last]="last">
                  <div class="approval-icon text-white" [ngClass]="approvalUiBadgeClass(approval)">
                    <i [class]="approvalUiIconClass(approval)"></i>
                  </div>
                  <div class="approval-content">
                    <div class="approval-header d-flex flex-wrap align-items-center gap-2 mb-1">
                      <span class="badge rounded-pill px-3 py-2" [ngClass]="approvalUiBadgeClass(approval)">
                        {{ approvalHeadline(approval) }}
                      </span>
                    </div>
                    <div class="approval-meta small text-muted mb-2">
                      <span class="approval-meta-item"
                        ><i class="fas fa-user-tie me-1 opacity-75"></i>{{ approvalStaffLabel(approval) }}</span
                      >
                      <span class="approval-meta-sep">·</span>
                      <span class="approval-meta-item"
                        ><i class="fas fa-layer-group me-1 opacity-75"></i>Nível:
                        {{ approvalLevelLabel(approval) || '—' }}</span
                      >
                      <span class="approval-meta-sep">·</span>
                      <span class="approval-meta-item"
                        ><i class="fas fa-sort-numeric-down me-1 opacity-75"></i>Ordem:
                        {{ approvalOrderLabel(approval) }}</span
                      >
                      <span class="approval-meta-sep">·</span>
                      <span class="approval-meta-item"
                        ><i class="fas fa-hashtag me-1 opacity-75"></i>Registro
                        {{ approvalRecordIdLabel(approval) }}</span
                      >
                      <span class="approval-meta-sep" *ngIf="approvalFlagFinal(approval)">·</span>
                      <span class="badge bg-dark bg-opacity-25" *ngIf="approvalFlagFinal(approval)">Etapa final</span>
                      <span class="approval-meta-sep" *ngIf="approvalFlagAutomatic(approval)">·</span>
                      <span class="badge bg-secondary" *ngIf="approvalFlagAutomatic(approval)">Automática</span>
                      <span class="approval-meta-sep" *ngIf="approvalFlagManager(approval)">·</span>
                      <span class="badge bg-primary bg-opacity-75" *ngIf="approvalFlagManager(approval)"
                        >Gestor</span
                      >
                    </div>
                    <div class="approval-datetime text-muted small mb-2">
                      <i class="far fa-clock me-1"></i>
                      <strong>Quando:</strong> {{ formatDateTime(approval.approvalDate) }}
                      <span *ngIf="approval.createdAt" class="ms-2">
                        · <strong>Inclusão:</strong> {{ formatDateTime(approval.createdAt) }}
                      </span>
                    </div>
                    <div class="approval-detail-stack">
                      <div class="approval-comments" *ngIf="approvalCommentsText(approval)">
                        <span class="approval-detail-label">Comentários</span>
                        {{ approvalCommentsText(approval) }}
                      </div>
                      <div class="approval-comments approval-comments-danger" *ngIf="approvalRejectionText(approval)">
                        <span class="approval-detail-label">Motivo da rejeição</span>
                        {{ approvalRejectionText(approval) }}
                      </div>
                      <div class="approval-comments approval-comments-info" *ngIf="approvalRequestedChangesText(approval)">
                        <span class="approval-detail-label">Alterações solicitadas</span>
                        {{ approvalRequestedChangesText(approval) }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Histórico de Status -->
      <div class="row mb-4" *ngIf="statusHistory.length > 0">
        <div class="col-12">
          <div class="info-card">
            <h5 class="card-title">
              <i class="fas fa-history me-2"></i>
              Histórico de Status
            </h5>
            <div class="card-body">
              <div class="timeline">
                <div
                  *ngFor="let history of statusHistory; let last = last"
                  class="timeline-item"
                  [class.timeline-item-last]="last">
                  <div class="timeline-marker"></div>
                  <div class="timeline-content">
                    <div class="timeline-header">
                      <span class="badge" [class]="getStatusClass(history.status)">
                        {{ getStatusDisplayName(history.status) }}
                      </span>
                      <small class="text-muted ms-2">
                        {{ formatDate(history.changedDate) }}
                      </small>
                    </div>
                    <div class="timeline-body" *ngIf="history.notes">
                      {{ history.notes }}
                    </div>
                    <div class="timeline-footer" *ngIf="history.changedByStaffName">
                      <small class="text-muted">
                        Alterado por: {{ history.changedByStaffName }}
                      </small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </ng-container>

      <ng-container *ngIf="detailsTab === 'approval-tracking' && !isSolicitacaoComprasFlow">
        <div class="approval-tracking-tab pb-4">
          <div *ngIf="approvalTrackingLoading" class="text-center py-5">
            <div class="spinner-border text-primary" role="status"></div>
            <p class="small text-muted mt-2 mb-0">Carregando rastreamento de aprovações…</p>
          </div>
          <div *ngIf="!approvalTrackingLoading && approvalTrackingError" class="alert alert-warning">
            {{ approvalTrackingError }}
          </div>
          <ng-container *ngIf="!approvalTrackingLoading && !approvalTrackingError && approvalTracking as track">
            <div class="info-card mb-3">
              <h5 class="card-title">
                <i class="fas fa-stream me-2"></i>
                Resumo do fluxo
              </h5>
              <div class="card-body">
                <div class="info-row">
                  <label>Pedido:</label>
                  <span>{{ track.orderNumber || ('#' + track.purchaseOrderId) }}</span>
                </div>
                <div class="info-row">
                  <label>Status:</label>
                  <span>{{ track.status || '—' }}</span>
                </div>
                <div class="info-row">
                  <label>Valor total:</label>
                  <span>{{ formatApprovalTrackingMoney(track.totalAmount) }}</span>
                </div>
              </div>
            </div>

            <div class="info-card mb-3" *ngIf="track.appliedRule as rule">
              <h5 class="card-title">
                <i class="fas fa-layer-group me-2"></i>
                Faixa de valor aplicada
              </h5>
              <div class="card-body">
                <div class="info-row">
                  <label>Regra:</label>
                  <span>{{ rule.ruleName || '—' }}</span>
                </div>
                <div class="info-row">
                  <label>Intervalo:</label>
                  <span
                    >{{ formatApprovalTrackingMoney(rule.minAmount) }} —
                    {{ formatApprovalTrackingMoney(rule.maxAmount) }}</span
                  >
                </div>
                <div class="info-row">
                  <label>Aprovações adicionais exigidas:</label>
                  <span>{{ rule.requiredAdditionalApprovalsCount ?? '—' }}</span>
                </div>
                <div class="info-row">
                  <label>Aprovação sequencial:</label>
                  <span>{{ rule.requiresSequentialApproval ? 'Sim' : 'Não' }}</span>
                </div>
                <p class="small text-muted mb-2 mt-2" *ngIf="rule.description">{{ rule.description }}</p>
                <div *ngIf="rule.additionalApprovers?.length">
                  <strong class="small d-block">Aprovadores na faixa</strong>
                  <ul class="small mb-0 mt-1 ps-3">
                    <li *ngFor="let ap of rule.additionalApprovers">
                      {{ ap.approvalOrder }}. {{ ap.staffName || ('Colaborador #' + ap.staffId) }}
                      <span class="text-muted">({{ ap.approvalLevel }})</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="info-card mb-3 border-warning border-top border-3" *ngIf="track.currentStep as cur">
              <h5 class="card-title">
                <i class="fas fa-crosshairs me-2"></i>
                Etapa atual
              </h5>
              <div class="card-body">
                <span class="badge me-2" [ngClass]="trackingStepBadgeClass(cur)">{{
                  cur.actionDisplayName || cur.action
                }}</span>
                <strong>{{ cur.approvalLevelDisplayName || cur.approvalLevel }}</strong>
                <div class="small text-muted mt-2">
                  {{ cur.staffName }} · ordem {{ cur.approvalOrder }}
                  <span *ngIf="cur.id != null" class="ms-1">· registro #{{ cur.id }}</span>
                </div>
                <div class="small mt-2" *ngIf="cur.comments">{{ cur.comments }}</div>

                <p class="small text-muted mt-3 mb-0 pt-3 border-top" *appHasPermission="'PurchaseOrders.Approve'">
                  <i class="fas fa-arrow-down me-1"></i>
                  Use os botões <strong>Aprovar</strong> / <strong>Rejeitar</strong> no card correspondente em
                  <strong>Etapas pendentes</strong> abaixo (registro #{{ cur.id }}).
                </p>
              </div>
            </div>

            <div class="info-card mb-3" *ngIf="track.pendingSteps?.length">
              <h5 class="card-title text-warning">
                <i class="fas fa-hourglass-half me-2"></i>
                Etapas pendentes
              </h5>
              <div class="card-body">
                <div
                  *ngFor="let step of track.pendingSteps"
                  class="border rounded p-3 mb-3 bg-light bg-opacity-50 po-pending-step">
                  <div class="row g-3 align-items-start">
                    <div class="col-12 col-lg">
                      <span class="badge me-2" [ngClass]="trackingStepBadgeClass(step)">{{
                        step.actionDisplayName || step.action
                      }}</span>
                      <strong>{{ step.approvalLevelDisplayName || step.approvalLevel }}</strong>
                      <div class="small text-muted mt-2">
                        {{ step.staffName }} · ordem {{ step.approvalOrder }}
                        <span *ngIf="step.id != null" class="ms-1">· registro #{{ step.id }}</span>
                      </div>
                      <div class="small mt-2" *ngIf="step.comments">{{ step.comments }}</div>
                    </div>
                    <div class="col-12 col-lg-auto po-pending-step-actions" *ngIf="step.id != null">
                      <ng-container *appHasPermission="'PurchaseOrders.Approve'">
                        <div *ngIf="canActOnApprovalStep(step)">
                          <div class="d-flex flex-wrap gap-2 justify-content-lg-end">
                            <button
                              type="button"
                              class="btn btn-success"
                              [disabled]="trackingDecisionBusyId === step.id"
                              (click)="openTrackingDecisionModal(step, 'approve')">
                              <i class="fas fa-check me-1" *ngIf="trackingDecisionBusyId !== step.id"></i>
                              <i class="fas fa-spinner fa-spin me-1" *ngIf="trackingDecisionBusyId === step.id"></i>
                              Aprovar
                            </button>
                            <button
                              type="button"
                              class="btn btn-danger"
                              [disabled]="trackingDecisionBusyId === step.id"
                              (click)="openTrackingDecisionModal(step, 'reject')">
                              <i class="fas fa-times me-1"></i>
                              Rejeitar
                            </button>
                          </div>
                        </div>
                        <div
                          *ngIf="!canActOnApprovalStep(step) && (step.action || '').trim() === 'Pendente'"
                          class="small text-muted border rounded p-2 bg-white">
                          <span *ngIf="step.canEdit === false">Esta etapa ainda não está liberada para decisão.</span>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="info-card mb-3" *ngIf="track.completedSteps?.length">
              <h5 class="card-title text-success">
                <i class="fas fa-check-double me-2"></i>
                Etapas concluídas
              </h5>
              <div class="card-body">
                <div *ngFor="let step of track.completedSteps" class="border rounded p-2 mb-2">
                  <span class="badge me-2" [ngClass]="trackingStepBadgeClass(step)">{{
                    step.actionDisplayName || step.action
                  }}</span>
                  <strong>{{ step.approvalLevelDisplayName || step.approvalLevel }}</strong>
                  <span class="small text-muted ms-2">{{ step.staffName }}</span>
                  <div class="small text-muted">{{ formatApprovalTrackingWhen(step.approvalDate) }}</div>
                  <div class="small mt-1" *ngIf="step.comments">{{ step.comments }}</div>
                </div>
              </div>
            </div>

            <!-- Próxima ação após todas as aprovações concluídas: indicar compra -->
            <div
              class="info-card mb-3 confirm-purchase-card"
              *ngIf="canConfirmPurchase()">
              <h5 class="card-title">
                <i class="fas fa-cart-shopping me-2"></i>
                Próxima ação — indicar compra
              </h5>
              <div class="card-body">
                <p class="mb-3">
                  Todas as aprovações foram concluídas. O pedido está pronto para
                  avançar para o fluxo de compra.
                </p>
                <ng-container *appHasPermission="'PurchaseOrders.Edit'">
                  <button
                    type="button"
                    class="btn btn-success"
                    [disabled]="isConfirmingPurchase"
                    (click)="openStockEntryModal()"
                    title="Indica a compra e envia a entrada para o estoque.">
                    <i class="fas fa-cart-shopping me-1" *ngIf="!isConfirmingPurchase"></i>
                    <i class="fas fa-spinner fa-spin me-1" *ngIf="isConfirmingPurchase"></i>
                    {{ isConfirmingPurchase ? 'Indicando…' : 'Indicar compra' }}
                  </button>
                </ng-container>
              </div>
            </div>

            <div class="info-card mb-3" *ngIf="track.statusHistory?.length">
              <h5 class="card-title">
                <i class="fas fa-history me-2"></i>
                Histórico de mudanças de status
              </h5>
              <div class="card-body">
                <div *ngFor="let h of track.statusHistory" class="small border-bottom py-2">
                  <div>
                    <strong>{{ h.newStatus || '—' }}</strong>
                    <span class="text-muted ms-2">{{ formatApprovalTrackingWhen(h.statusDate) }}</span>
                  </div>
                  <div class="text-muted">Anterior: {{ h.previousStatus || '—' }}</div>
                  <div *ngIf="h.action">{{ h.action }}</div>
                  <div *ngIf="h.comments || h.reason">{{ h.comments || h.reason }}</div>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </ng-container>

    </div>
  </div>

  <!-- Modal «Indicar compra → estoque»: entrada + send-to-approval + confirm-purchase -->
  <app-modal
    [isOpen]="showStockEntryModal"
    [title]="'Indicar compra — enviar entrada para o estoque'"
    [size]="'xl'"
    [closable]="!isConfirmingPurchase"
    (close)="closeStockEntryModal()">
    <div *ngIf="showStockEntryModal">
      <div class="alert alert-info py-2 small mb-3"
        *ngIf="isLoadingWinnerProposal || isLoadingWarehouses">
        <i class="fas fa-spinner fa-spin me-1"></i>
        Carregando dados do pedido...
      </div>

      <div class="alert alert-warning py-2 small mb-3"
        *ngIf="!isLoadingWinnerProposal && !hasWinnerProposal && stockEntryForm.lines.length > 0">
        Nenhuma proposta vencedora encontrada — os custos foram preenchidos pelo valor estimado original.
        Revise antes de enviar.
      </div>

      <div class="row g-2 mb-3">
        <div class="col-md-6">
          <label class="form-label">
            Almoxarifado <span class="text-danger">*</span>
          </label>
          <div class="input-group">
            <select class="form-select"
              [(ngModel)]="stockEntryForm.warehouseId"
              [disabled]="isLoadingWarehouses || isConfirmingPurchase || warehouses.length === 0">
              <option [ngValue]="null" *ngIf="isLoadingWarehouses">Carregando almoxarifados...</option>
              <option [ngValue]="null" *ngIf="!isLoadingWarehouses && warehouses.length > 0">Selecione...</option>
              <option [ngValue]="null" *ngIf="!isLoadingWarehouses && warehouses.length === 0 && !warehousesLoadError">
                Nenhum almoxarifado cadastrado
              </option>
              <option [ngValue]="null" *ngIf="!isLoadingWarehouses && warehousesLoadError">
                Falha ao carregar almoxarifados
              </option>
              <option *ngFor="let w of warehouses" [ngValue]="w.id">
                {{ w.code }} — {{ w.name }}
              </option>
            </select>
            <button type="button"
              class="btn btn-outline-secondary"
              title="Recarregar almoxarifados"
              [disabled]="isLoadingWarehouses || isConfirmingPurchase"
              (click)="reloadWarehouses()">
              <i class="fas" [class.fa-sync-alt]="!isLoadingWarehouses"
                [class.fa-spinner]="isLoadingWarehouses"
                [class.fa-spin]="isLoadingWarehouses"></i>
            </button>
          </div>
          <small class="text-muted" *ngIf="warehouses.length > 0">
            Todos os itens serão registrados neste almoxarifado.
          </small>
          <small class="text-danger" *ngIf="!isLoadingWarehouses && warehousesLoadError">
            Não foi possível carregar a lista — verifique conexão/permissão e tente recarregar.
          </small>
          <small class="text-warning"
            *ngIf="!isLoadingWarehouses && !warehousesLoadError && warehouses.length === 0">
            Cadastre ao menos um almoxarifado em Estoque › Almoxarifados para indicar a compra.
          </small>
        </div>
        <div class="col-md-6">
          <label class="form-label">Notas gerais</label>
          <input type="text" class="form-control"
            [(ngModel)]="stockEntryForm.notes"
            [disabled]="isConfirmingPurchase"
            maxlength="200" />
        </div>
      </div>

      <div class="table-responsive" *ngIf="stockEntryForm.lines.length; else noLines">
        <table class="table table-sm align-middle stock-entry-table mb-0">
          <thead class="table-light">
            <tr>
              <th>Nome <span class="text-danger">*</span></th>
              <th>Código</th>
              <th>Cód. fornecedor</th>
              <th>Unidade <span class="text-danger">*</span></th>
              <th class="text-end">Custo unit.</th>
              <th>Categoria</th>
              <th class="text-end">Quantidade <span class="text-danger">*</span></th>
              <th>Nota</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let l of stockEntryForm.lines">
              <td>
                <input type="text" class="form-control form-control-sm"
                  [(ngModel)]="l.expectedItem.name"
                  [disabled]="isConfirmingPurchase"
                  maxlength="200" />
              </td>
              <td>
                <input type="text" class="form-control form-control-sm"
                  [(ngModel)]="l.expectedItem.code"
                  [disabled]="isConfirmingPurchase"
                  maxlength="80" />
              </td>
              <td>
                <input type="text" class="form-control form-control-sm"
                  [(ngModel)]="l.expectedItem.supplierCode"
                  [disabled]="isConfirmingPurchase"
                  maxlength="80" />
              </td>
              <td style="width: 90px;">
                <input type="text" class="form-control form-control-sm"
                  [(ngModel)]="l.expectedItem.unitOfMeasure"
                  [disabled]="isConfirmingPurchase"
                  maxlength="10" />
              </td>
              <td style="width: 130px;" class="text-end">
                <input type="number" class="form-control form-control-sm text-end"
                  [(ngModel)]="l.expectedItem.estimatedUnitCost"
                  [disabled]="isConfirmingPurchase"
                  min="0" step="0.01" />
              </td>
              <td>
                <input type="text" class="form-control form-control-sm"
                  [(ngModel)]="l.expectedItem.category"
                  [disabled]="isConfirmingPurchase"
                  maxlength="80" />
              </td>
              <td style="width: 110px;" class="text-end">
                <input type="number" class="form-control form-control-sm text-end"
                  [(ngModel)]="l.quantity"
                  [disabled]="isConfirmingPurchase"
                  min="0" step="1" />
              </td>
              <td>
                <input type="text" class="form-control form-control-sm"
                  [(ngModel)]="l.note"
                  [disabled]="isConfirmingPurchase"
                  maxlength="160" />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <ng-template #noLines>
        <div class="alert alert-secondary mb-0">
          Nenhum item disponível neste pedido para enviar ao estoque.
        </div>
      </ng-template>
    </div>
    <div slot="footer" class="d-flex justify-content-end gap-2">
      <button
        type="button"
        class="btn btn-outline-secondary"
        [disabled]="isConfirmingPurchase"
        (click)="closeStockEntryModal()">
        Cancelar
      </button>
      <button
        type="button"
        class="btn btn-success"
        [disabled]="!canSubmitStockEntry() || isConfirmingPurchase"
        (click)="submitStockEntryAndConfirmPurchase()">
        <i class="fas fa-spinner fa-spin me-1" *ngIf="isConfirmingPurchase"></i>
        <i class="fas fa-cart-shopping me-1" *ngIf="!isConfirmingPurchase"></i>
        {{ isConfirmingPurchase ? 'Enviando…' : 'Indicar compra' }}
      </button>
    </div>
  </app-modal>

  <div class="po-tracking-modal-backdrop" *ngIf="trackingModalOpen">
    <div class="po-tracking-modal card shadow-lg">
      <div class="card-header d-flex justify-content-between align-items-center">
        <h5 class="mb-0">{{ trackingModalTitle }}</h5>
        <button
          type="button"
          class="btn-close"
          aria-label="Fechar"
          [disabled]="trackingDecisionBusyId != null"
          (click)="closeTrackingDecisionModal()"></button>
      </div>
      <div class="card-body">
        <label class="form-label">{{ trackingModalCommentLabel }}</label>
        <textarea
          class="form-control"
          rows="4"
          [(ngModel)]="trackingModalComment"
          name="trackingModalComment"
          [placeholder]="trackingModalCommentPlaceholder"></textarea>
      </div>
      <div class="card-footer d-flex justify-content-end gap-2">
        <button
          type="button"
          class="btn btn-outline-secondary"
          [disabled]="trackingDecisionBusyId != null"
          (click)="closeTrackingDecisionModal()">
          Cancelar
        </button>
        <button
          type="button"
          class="btn"
          [ngClass]="{
            'btn-success': trackingModalConfirmLabel === 'Confirmar aprovação',
            'btn-danger': trackingModalConfirmLabel === 'Confirmar rejeição',
            'btn-primary': trackingModalConfirmLabel === 'Confirmar solicitação'
          }"
          [disabled]="trackingDecisionBusyId != null"
          (click)="confirmTrackingDecisionFromModal()">
          <i class="fas fa-spinner fa-spin me-1" *ngIf="trackingDecisionBusyId != null"></i>
          {{ trackingModalConfirmLabel }}
        </button>
      </div>
    </div>
  </div>
</app-side-menu>
